module.exports = __webpack_public_path__ + "img/circulateNumber.4b65d2a0.png";